// src/components/EventManager.tsx
import React, { useState } from 'react';
import { Show } from '../types';
import CreateEventForm from './CreateEventForm';

interface EventManagerProps {
  shows: Show[];
  onUpdateShows: (updatedShows: Show[]) => void;
}

const formatJSObject = (show: Show) => {
  return `{
  id: ${show.id},
  date: new Date('${show.date}'),
  city: '${show.city}',
  venue: '${show.venue}',
  time: new Date('${show.time}'),
  ticketInfo: '${show.ticketInfo}',
  ticketLink: '',
  image: '${show.image}',
  description: '${show.description}',
  hotelInfo: {
    name: '${show.hotelInfo?.name}',
    address: '${show.hotelInfo?.address}',
    checkIn: '${show.hotelInfo?.checkIn}',
    checkOut: '${show.hotelInfo?.checkOut}',
    rooms: '${show.hotelInfo?.rooms}'
  },
  flightInfo: {
    arrival: '${show.flightInfo?.arrival}',
    departure: '${show.flightInfo?.departure}'
  }
}`;
};

const EventManager: React.FC<EventManagerProps> = ({ shows, onUpdateShows }) => {
  const [showList, setShowList] = useState<Show[]>(shows);
  const [newEventFormatted, setNewEventFormatted] = useState<string | null>(null);

  const handleCreateEvent = (newShow: Show) => {
    const updatedShows = [...showList, newShow];
    setShowList(updatedShows);
    onUpdateShows(updatedShows);
    setNewEventFormatted(formatJSObject(newShow));
  };

  return (
    <div className="space-y-8">
      {/* Event List commented out */}

      {/* Create Event Form Section */}
      <CreateEventForm onCreate={handleCreateEvent} />

      {/* Formatted JS Object Output */}
      {newEventFormatted && (
        <div className="mt-6 bg-gray-900 text-green-400 p-4 rounded-lg">
          <h3 className="text-lg font-bold mb-2">Formatted Event Object:</h3>
          <textarea
            className="w-full h-64 p-2 bg-gray-800 text-green-300 rounded resize-none font-mono"
            value={newEventFormatted}
            readOnly
          />
          <button
            className="mt-2 bg-blue-500 text-white px-4 py-2 rounded"
            onClick={() => {
              navigator.clipboard.writeText(newEventFormatted);
              alert('Copied to clipboard!');
            }}
          >
            Copy Object
          </button>
        </div>
      )}
    </div>
  );
};

export default EventManager;
